import { render, staticRenderFns } from "./ListDestination.vue?vue&type=template&id=78c87d40&scoped=true"
import script from "./ListDestination.vue?vue&type=script&lang=js"
export * from "./ListDestination.vue?vue&type=script&lang=js"
import style0 from "./ListDestination.vue?vue&type=style&index=0&id=78c87d40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c87d40",
  null
  
)

export default component.exports